(function () {
  function checkRequiredFields(simpleCard) {
    const requiredFields = simpleCard.querySelectorAll('[required="true"]');

    // If there were no errors, remove any existing error message
    const errorElement = simpleCard.querySelector('.error-message');
    if (errorElement) {
      errorElement.remove();
    }

    // click on edit button to collapse the form
    const toggleButton = simpleCard.querySelector('.toggle-content');
    if (toggleButton.hasAttribute('hidden')) {
      toggleButton.removeAttribute('hidden');
      toggleButton.style.display = 'inline-flex';
    }
    //Show status bar
    const status = simpleCard.querySelector('.status-bar');
    status.setAttribute('aria-hidden', false);
    status.removeAttribute('hidden');

    toggleButton.click();

    simpleCard.scrollIntoView({ behavior: 'smooth' });

    // Return true if there are no errors
    return;
  }

  document.addEventListener('click', function (event) {
    if (event.target.classList.contains('js-validate-fields')) {
      const simpleCard = event.target.closest('.simple-card');
      checkRequiredFields(simpleCard);
    }
  });
})();
